import { Observable } from 'rxjs';
import { EntityId } from '@shared/core/types';
import { MailCompose } from '../types';

export abstract class MailReplyService {
  abstract reply(messageId: EntityId, reply: MailCompose): Observable<any>;
}
